import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const FinalCTA: React.FC = () => {
  const { t } = useTranslation();

  const handleContactClick = () => {
    window.location.href = '/contato';
  };

  return (
    <section className="section bg-brand-slate text-brand-sand">
      <div className="wrapper">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-3xl md:text-5xl font-heading text-brand-sand mb-6">
            {t('finalCta.title')}
          </h2>
          
          <p className="text-lg text-brand-sand/90 mb-8 max-w-2xl mx-auto">
            {t('finalCta.text')}
          </p>

          <div className="flex justify-center">
            <button
              onClick={handleContactClick}
              className="btn bg-transparent text-brand-sand border-2 border-brand-sand hover:bg-brand-sand hover:text-brand-slate text-lg px-8 py-4"
            >
              {t('finalCta.cta2')}
              <ArrowRight size={20} />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;